import BasicCryp from "../../services/cryp/BasicCryp";
import SocketClient from "../../services/socket/SocketClient";
import DataFactory from "../../services/type1/DataFactory";
import ILocalCache from "./interfaces/ILocalCache";
import IToken from "./interfaces/IToken";
import { IUser } from "./interfaces/IUser";


export class CurrentUser {
    public static Token?: IToken;
    public static User?: IUser;
    public static UpdateFooter?: (user: IUser) => void;
    public static OnLogin: ((user: IUser) => void)[] = [];
    public static CheckLogin?: () => void;
    public static CheckLocalCache() {
        let localCache = window.sessionStorage.getItem('cache');
        let localHash = window.sessionStorage.getItem('hash');

        if (localCache && localHash) {
            let decoded = BasicCryp.Decode(localCache);

            try {

                let cache: ILocalCache = JSON.parse(decoded);
                let hash = BasicCryp.Decode(localHash);

                hash = hash.replace('_padstart', '').replace('padend_', '');

                let lenght = Number.parseInt(hash);

                if (Number.isNaN(lenght) || decoded.length != lenght) {
                    CurrentUser.Token = undefined;
                    CurrentUser.User = undefined;
                    window.sessionStorage.clear();
                    return;
                }
                else if ('Token' in cache && 'User' in cache) {
                    if (new Date(cache.Token.ExpiresAt) > new Date()) {
                        CurrentUser.Token = cache.Token;
                        CurrentUser.User = cache.User;

                        SocketClient.Start();

                        if (CurrentUser.UpdateFooter) {
                            CurrentUser.UpdateFooter(CurrentUser.User!);
                        }

                       
                        for (let func of CurrentUser.OnLogin) {
                            func(CurrentUser.User!);
                        }

                        return;
                    }
                }

            } catch { }

            CurrentUser.Token = undefined;
            CurrentUser.User = undefined;
        }
    }


    public static LogOff()
    {
        window.sessionStorage.clear();
        window.location.href = "/";
    }

}
